const video = {
  btns: document.querySelectorAll<HTMLElement>('.jsLoadVideo'),
  eles: document.querySelectorAll<HTMLElement>('.jsVideoPlayer'),

  init() {
    this.setVideo();
  },

  setVideo() {
    if (!this.btns.length || !this.eles.length) return;

    this.btns.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        const videoId = btn.dataset.videoId;

        if (!videoId) return;

        this.eles.forEach((ele, eleIndex) => {
          if (index !== eleIndex) return;

          ele.innerHTML = `
            <iframe 
              src="https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowfullscreen
              style="width: 100%; height: 100%; border: none;">
            </iframe>
          `;
        });
      });
    });
  },
};

export default video;